import './DataSection.css';
import {useEffect, useState} from "react";
import DataForm from "../DataForm/DataForm.jsx";
import DataBlock from "../DataBlock/DataBlock.jsx";
import {getDeliveryAddresses} from "../../../../../../CustomerHandler.js";

export default function DataSection({ label, data, type, setShipmentData }) {
    const [displayForm, setDisplayForm] = useState(false);
    const [editID, setEditID] = useState(null);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        document.documentElement.style.overflow = displayForm ? 'hidden' : '';
        return () => (document.documentElement.style.overflow = '');
    }, [displayForm]);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        if (displayForm) scrollToTop();
    }, [displayForm]);

    const handleEdit = (id) => {
        const item = data.find(d => d.id === id);
        if (!item) return;
        setEditID(id);
        setEditData(item);
        setDisplayForm(true);
    };

    return (
        <div className='data-section'>
            {displayForm && (
                <DataForm
                    setDisplayForm={setDisplayForm}
                    type={type}
                    setEditID={setEditID}
                    editID={editID}
                    editData={editData}
                    refreshData={() =>
                        getDeliveryAddresses(sessionStorage.getItem("customerAccessToken")).then(setShipmentData)
                    }
                />
            )}
            <div className='data-section-top'>
                <span className='data-section-label'>{label}</span>
            </div>
            <div className='data-section-bottom'>
                {data.map((item, index) => (
                    <DataBlock item={item} key={index} type={type} setEditID={handleEdit} />
                ))}
                <div
                    className='data-section-add-btn'
                    onClick={() => {
                        setEditID(null);
                        setEditData(null);
                        setDisplayForm(true);
                    }}
                >
                    <img loading="lazy" src='/images/add-icon.webp' alt="" />

                </div>
            </div>
        </div>
    );
}
